import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { mediaQueries } from 'styles/utils/mediaQueries';
import Departure from './components/departure/DepartureComponent';
import HasMore from './components/hasMore/HasMoreComponent';

function DeparturesComponent({ departures, hasMoreDepartures, language }) {
  return (
    <Root>
      {departures.map(({ departureAirport, fromDate, toDate }, index) => {
        const date = moment(fromDate).locale(language).format('LL');
        const duration = moment(toDate).diff(moment(fromDate), 'days');

        return (
          <Departure key={`departure-${index}`} date={date} departureAirport={departureAirport} duration={duration} />
        );
      })}
      {!isNaN(hasMoreDepartures) && hasMoreDepartures > 0 && <HasMore hasMore={hasMoreDepartures} />}
    </Root>
  );
}

export default DeparturesComponent;

const Root = styled.div`
  display: flex;
  flex-wrap: wrap;

  ${mediaQueries.fromAndBelow.tablet`
		max-width: 250px;
  `}
`;
